import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/logo@2x.png'


const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = { class: "header-with-estate-logo" }
const _hoisted_3 = { class: "estate-logo-wr" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_2, [
    _createElementVNode("div", _hoisted_3, [
      ($setup.props.estate?._id)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'EstateMap', params: { estateId: $setup.props.estate._id } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: $setup.props.estate?.logoUrl
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                srcset: _hoisted_1
              }, null, -1)
            ]))]),
            _: 1
          }))
    ])
  ]))
}